import { BackButton as FellesBackButton } from "@sb1f/buttons";
import type { BackButtonProps } from "@sb1/ffe-buttons-react";
import { getCustomData } from "~/utils/tracking/utils";
import type { ElementType } from "react";

type Props<As extends ElementType = "button"> = BackButtonProps<As> & {
	track?: boolean;
	knappNavn?: string;
	trackingData?: object;
};

const BackButton = <As extends ElementType = "button">({ track = true, trackingData, ...props }: Props<As>) => {
	const customData = trackingData ? { ...trackingData, ...getCustomData() } : getCustomData();
	return <FellesBackButton customData={customData} {...props} />;
};

export default BackButton;
